export const defaultNextBillingDateText =
  'Без абон. платы, оплачиваются только использованные минуты, SMS и интернет';

export const CORPORATE_BALANCE_TEXT = 'корпоративный лимит пополнится';
